export const iframe = {
  url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3343.8103901780005!2d-96.87637462521796!3d33.06145836939692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c24d129e1b389%3A0x164b880cc4e3a583!2s5551%20Windhaven%20Pkwy%2C%20Lewisville%2C%20TX%2075056!5e0!3m2!1sen!2sus!4v1779299929016!5m2!1sen!2sus",
};
